import { TuiButtonModule } from '@taiga-ui/core';
import { Maybe } from '@iss/libs/graphql';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'wo-show-more-input-button',
  templateUrl: './show-more-input-button.component.html',
  styleUrls: [ './show-more-input-button.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TuiButtonModule,
  ],
})
export class ShowMoreInputButtonComponent {
  @Input({ required: true }) public value!: Maybe<boolean>;
  @Input() public loading: Maybe<boolean>;
  @Output() public readonly toggle = new EventEmitter();
}
